import { render, staticRenderFns } from "./contactUser.vue?vue&type=template&id=8d42b41a&"
import script from "./contactUser.vue?vue&type=script&lang=js&"
export * from "./contactUser.vue?vue&type=script&lang=js&"
import style0 from "./contactUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports